import React from 'react'

import Navbar from '../Navbar'

import HomeFooter from '../HomeFooter/HomeFooter'
import StoryDetail from './StoryDetail'

export const CompStory = () => {
  return (
   <>
   <Navbar/>
   <StoryDetail />
   <HomeFooter />

   </>
  )
}
